module.exports = __webpack_public_path__ + "static/img/cab-dualmic.fee5842.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/cab/cab-dualmic.jpg
// module id = XeXi
// module chunks = 12